import React, { Component } from 'react';
import { connect } from 'react-redux';
import Filter from '../../Layout/Filter';
import API from '../../../../Configs';
import Actions from '../../../../Actions';

class ReportHead extends Component {
    constructor(props){
        super(props);
        this.meta = API.REPORTS;
        this.ageMeta = API.REPORT_AGES;
        this.reportType = this.meta[props.reportId];
    }

    render(){
        const { reportId, query, getReports } = this.props;
        const { title, dataType, queryField } = this.reportType;
        return(
            <tr key="header1">
                <th className="text-left">
                    <Filter query={query} id="report-title" title={title} pid={reportId} field={queryField} filter={getReports} />
                </th>
                <th className="text-right">
                    <Filter query={query} id="report-total" title="Total" pid={reportId} field="total" filter={getReports} />
                </th>
                {dataType === 1 ? 
                    <th className="text-right">
                        <Filter query={query} id="report-open" title="Open" pid={reportId} field="open" filter={getReports} />
                    </th> 
                :false}
                {dataType === 1 ?
                    Object.keys(API.STATUSES).map((id) => (
                        <th className="text-right" key={id}>
                            <Filter query={query} id={`report-s${id}`} title={API.STATUSES[id].name} pid={reportId} field={`s${id}`} filter={getReports} />
                        </th>
                    ))
                    :                    
                    Object.keys(this.ageMeta).map((id) => (
                        <th className="text-right" key={id}>
                            <Filter query={query} id={`report-s${id}`} title={`${this.ageMeta[id].title}`} pid={reportId} field={`s${id}`} filter={getReports} />
                        </th>
                    ))
                }
            </tr>
        );
    }
}

const mapStateToProps = (state) => ({
    query: state.reportStore.query,
});

export default connect(mapStateToProps,Actions.reports)(ReportHead);


// WEBPACK FOOTER //
// ./src/Components/App/Reports/TabularReport/ReportHead.js